import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-more\"><circle class=\"cls-1\" cx=\"158.783\" cy=\"511.81\" r=\"92.411\" /><circle class=\"cls-1\" cx=\"866.922\" cy=\"512.848\" r=\"92.411\" /><circle class=\"cls-1\" cx=\"512.853\" cy=\"511.81\" r=\"92.411\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol